import api from '../api';

const HumanResourcesService = {
  async listEmployees(params = {}) {
    const response = await api.get('/human-resources/employees', { params });
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async getEmployeeById(id) {
    const response = await api.get(`/human-resources/employees/${id}`);
    return response?.data ?? null;
  },

  async getAvailableUsers() {
    const response = await api.get('/human-resources/employees/available-users');
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async listEmployeeHistory(params = {}) {
    const response = await api.get('/human-resources/employees/history', { params });
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async createEmployeeHistory(payload) {
    const response = await api.post('/human-resources/employees/history', payload);
    return response?.data ?? null;
  },

  async updateEmployeeHistory(id, payload) {
    const response = await api.put(`/human-resources/employees/history/${id}`, payload);
    return response?.data ?? null;
  },

  async deleteEmployeeHistory(id) {
    await api.delete(`/human-resources/employees/history/${id}`);
  },

  async createEmployee(payload) {
    const response = await api.post('/human-resources/employees', payload);
    return response?.data ?? null;
  },

  async updateEmployee(id, payload) {
    const response = await api.put(`/human-resources/employees/${id}`, payload);
    return response?.data ?? null;
  },

  async deleteEmployee(id) {
    await api.delete(`/human-resources/employees/${id}`);
  },

  async getOverview() {
    const response = await api.get('/human-resources/reports/overview');
    return response?.data ?? null;
  },

  async listVacationControl() {
    const response = await api.get('/human-resources/vacations');
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async getVacationControlById(id) {
    const response = await api.get(`/human-resources/vacations/${id}`);
    return response?.data ?? null;
  },

  async downloadEmployeesReport(params = {}) {
    const response = await api.get('/human-resources/reports/employees.csv', {
      params,
      responseType: 'blob',
    });
    const disposition = response?.headers?.['content-disposition'] || '';
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    let fileName = `relatorio-colaboradores-${new Date().toISOString().slice(0, 10)}.csv`;
    if (match && match[1]) {
      try {
        fileName = decodeURIComponent(match[1]);
      } catch (error) {
        fileName = match[1];
      }
    }
    return { blob: response?.data, fileName };
  },

  async downloadEmployeesPdf(params = {}) {
    const response = await api.get('/human-resources/reports/employees.pdf', {
      params,
      responseType: 'blob',
    });
    const disposition = response?.headers?.['content-disposition'] || '';
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    let fileName = `relatorio-colaboradores-${new Date().toISOString().slice(0, 10)}.pdf`;
    if (match && match[1]) {
      try {
        fileName = decodeURIComponent(match[1]);
      } catch (error) {
        fileName = match[1];
      }
    }
    return { blob: response?.data, fileName };
  },
};

export default HumanResourcesService;
